
import { defineComponent, ref } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    value: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    }
  }
})

export const setupAlertDialogCtx = () => {
  const isOpenedAlertDialog = ref(false)

  const openAlertDialog = () => (isOpenedAlertDialog.value = true)
  const closeAlertDialog = () => (isOpenedAlertDialog.value = false)

  return {
    isOpenedAlertDialog,
    openAlertDialog,
    closeAlertDialog
  }
}
